import './App.css'; 

function App() {
  return (
    <div>
      <h1>Hello, World!</h1>
      <p>React application.</p>
      <button>Click Me</button>
    </div>
  );
}

export default App;
